// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__o0OKg","consentsList":"PatientConsents_consentsList__fz-ls","consentsListEmpty":"PatientConsents_consentsListEmpty__NIQIu"};